
import React, { useState } from 'react';
import hamburgerIcon from '../assets/images/hamburger.png';
import BellIcon from '../assets/images/bell.png';
import { useSelector } from 'react-redux';
import { selectHeaderInfo } from '../redux/common/selector';
import { Container } from 'react-bootstrap';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { setSession } from '../utils/comman/authHelper';


export default function Header({
    toggleSidebar,
    showHamburger = true,
    showNotification = true,
    userInitials = 'SA',
}) {

    
    const auth = useAuth();
    const navigate = useNavigate();

    // Fetch header info from redux
    const { title, subtitle } = useSelector(selectHeaderInfo);

    const [showDropdown, setShowDropdown] = useState(false);

    const handleLogout = () => {
        auth.logout(() => {
            localStorage.clear(); 
            setSession(null);// optional: also call `setSession(null)` if using that
            navigate('/login');   // redirect to login
        });
    };

    return (
        <>
            <Container>
                <header className="d-flex justify-content-between align-items-center py-2">

                    {/* Left side: hamburger + titles */}
                    <div className="d-flex align-items-center gap-3">
                        {showHamburger && (
                            <button className="btn d-block d-sm-none me-2" onClick={toggleSidebar}>
                                <img src={hamburgerIcon} alt="Menu" style={{ height: "20px", width: "20px" }} />
                            </button>
                        )}
                        <div>
                            <h1 className="dashheading mb-0">{title}</h1>
                            <p className="dashsubheading mb-0">{subtitle}</p>
                        </div>
                    </div>

                    {/* Right side: bell + initials */}
                    <div className="d-flex align-items-center gap-3">
                        {showNotification && (
                            <img src={BellIcon} alt="Notifications" style={{ height: "22px", width: "20px", cursor: "pointer" }} />
                        )}
                        <div className="username" style={{ position: 'relative' }}>
                            <p className="mb-0" style={{ cursor: 'pointer' }} onClick={() => setShowDropdown(!showDropdown)}>{userInitials}</p>
                            {showDropdown && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '100%',
                                        right: 0,
                                        backgroundColor: 'white',
                                        border: '1px solid #ccc',
                                        padding: '16px 13px',
                                        zIndex: 1000,
                                        width: "200px",
                                        borderRadius: "5px"
                                    }}
                                >
                            <Button variant="contained" onClick={handleLogout}>Logout</Button>
                        </div>
                            )}
                    </div>
                </div>
            </header>
        </Container >

        </>
    );
}
